var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modals-header',_vm._b({},'modals-header',_vm.$attrs,false),[_c('svg-exclamation-triangle'),_vm._v(" Confirmation Required ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }